export type FiberListProps = { outletId: string; nodeType: NodeTypes };

export const nodeTypes = {
  TP_Outlet: 'tpOutlet',
  TECHNICAL_EQUIPMENT: 'technicalEquipment',
  WIFI_DOT: 'wifiDot',
} as const;

export type NodeTypes = typeof nodeTypes[keyof typeof nodeTypes];
